import { Inject, Injectable, Optional } from '@angular/core';
import {
  MatMomentDateAdapterOptions,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import moment from 'moment';
import { Moment } from 'moment';

@Injectable({
  providedIn: 'root',
})
export class MiqDateAdapterService extends MomentDateAdapter {
  constructor(
    @Optional() @Inject(MAT_DATE_LOCALE) dateLocale: string,
    @Inject(MAT_MOMENT_DATE_ADAPTER_OPTIONS)
    _options?: MatMomentDateAdapterOptions
  ) {
    super(dateLocale, _options);
  }

  today(): Moment {
    return moment();
  }
}
